import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const RE_PROJECTS_ENDPOINTS = {
  V2: createEndpoints('v2', {
    REAL_ESTATE: '/projects/',
    REAL_ESTATE_DETAIL: (id: number) => `/projects/${id}/`,
    REAL_ESTATE_TYPES: '/projects/types/',
    REAL_ESTATE_STATUS: '/projects/statuses/',
    REAL_ESTATE_SOURCES: '/projects/sources/',
    REAL_ESTATE_COMPANY: (companyId: number) => `/companies/${companyId}/projects/`,
    REAL_ESTATE_DELETE: '/projects/bulk-delete/',
  }),
} as const;
